import React from 'react';
import { principles } from '../data/content';
import { Reveal } from './ui/Reveal';
export function WhyLima() {
  return <section id="why-lima" aria-labelledby="why-lima-title" className="scroll-mt-24 bg-ink py-24 text-white lg:py-40" data-id="element-496" data-mp="2k9fxd8hh4d1q">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-497" data-mp="26daq1jhoh2ur">
        <Reveal className="max-w-[860px]" data-id="element-498" data-mp="2b8hrslrdzxh1">
          <p className="eyebrow flex items-center gap-3 text-accent" data-id="element-499" data-mp="1wl4z8d35wrh5">
            <span aria-hidden="true" className="h-px w-8 bg-accent" data-id="element-500" data-mp="1wj22793ldy2x" />
            Why Lima Dental
          </p>
          <h2 id="why-lima-title" className="font-display mt-7 text-[clamp(2.1rem,4.6vw,3.6rem)] leading-[1.05]" data-id="element-501" data-mp="21dpu7hxt1am9">
            We are not a chain.
            <br data-id="element-502" data-mp="1rmbm4lrsf2hi" />
            We are your neighbors.
          </h2>
          <p className="mt-7 max-w-[62ch] text-[16.5px] leading-[1.85] text-white/65" data-id="element-503" data-mp="1dnbztkrqyzoi">
            For more than 35 years we have built our practice on relationships, trust and honest
            recommendations. You will not find pressure here to accept treatment you do not
            need. Our approach always starts with your health.
          </p>
        </Reveal>

        <ul className="mt-20 grid gap-px border-t border-white/10 lg:mt-28 lg:grid-cols-3" data-id="element-504" data-mp="3gqjpj792qeab">
          {principles.map((principle, index) => <Reveal as="li" key={principle.number} delay={index * 0.07} className={`border-b border-white/10 py-10 lg:border-b-0 lg:py-14 lg:pr-10 ${index > 0 ? 'lg:border-l lg:border-white/10 lg:pl-10' : ''}`} data-id="element-505" data-mp="3bs8h90yfgbu7" data-mpi={index}>
              <span className="text-[12px] font-medium tracking-[0.2em] text-accent" data-id="element-506" data-mp="2xt8szuettyyk">
                {principle.number}
              </span>
              <h3 className="font-display mt-7 text-[24px] leading-[1.18]" data-id="element-507" data-mp="25bd5twgwgtqx">
                {principle.title}
              </h3>
              <p className="mt-3.5 max-w-[36ch] text-[15.5px] leading-relaxed text-white/60" data-id="element-508" data-mp="20biexsx4k45v">
                {principle.body}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}